// App.tsx - Configuración de rutas y providers principales
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/Layout';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Profile from './pages/Profile';
import Ranking from './pages/Ranking';
import ResetPassword from './pages/ResetPassword';
import Legal from './pages/Legal';
import Minesweeper from './pages/Minesweeper';
import Snake from './pages/Snake';
import { useAuthStore } from './store/authStore';
import { useHeartbeat } from './hooks/useHeartbeat';
import { Toaster } from 'sileo';
import 'sileo/styles.css';

// Componente para rutas protegidas (requieren autenticación)
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/auth" replace />;
}

// Componente para rutas públicas (redirige si ya está autenticado)
function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return !isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
}

export default function App() {
  const { initAuth } = useAuthStore();
  useHeartbeat();

  // Inicializar autenticación desde localStorage al cargar la app
  useEffect(() => {
    initAuth();
  }, [initAuth]);

  return (
    <>
    <Toaster position="top-right" />
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path="auth"
            element={
              <PublicRoute>
                <Auth />
              </PublicRoute>
            }
          />

          {/* Rutas protegidas */}
          <Route
            path="profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route path="ranking" element={<Ranking />} />

          <Route path="buscaminas" element={<Minesweeper />} />
          <Route path="snake" element={<Snake />} />

          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="privacidad" element={<Legal />} />
          <Route path="terminos" element={<Legal />} />
          <Route path="aviso-legal" element={<Legal />} />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </>
  );
}
